import api from "./api";
import axios from "axios";

var config = {

  apipath: window.location.origin+"/api/",
  wppath:window.location.origin+"/",

}
if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1" || window.location.hostname === "woodstock.local") {

  config.apipath = 'http://woodstock.local:8007/api/';
  config.wppath = 'http://woodstock.local:8007/';
}
window.config = config;

//import {types} from "util";
const getPublicContent = (searchstring,isPro) => {
  if (typeof searchstring === "undefined") {
    var searchstring = "";
  }

  if(typeof isPro === "undefined") {
    var isPro = false
  }

  if(isPro===false && window.location.href.indexOf("typ=Entsorgungsstation") === -1) {
    searchstring += "&hasfilter=1&pitch=1&service=0";
  }

  console.log(config.apipath+"?action=search" + searchstring);

  return api.get(
      config.apipath+"?action=search" + searchstring
  );
};

//Check local storage and if not make a new get request
const getDetailFields = (id) => {
  return api.get(config.apipath+"?id=" + id);
};

const getProfileFields = (pid, token) => {
  return api.get(
    config.apipath+"?action=get_profile&pid=" +
      pid +
      "&token=" +
      token
  );
};

const getTourenArray = () => {
  return api.get(
      config.wppath+"wp-json/wp/v2/touren?_embed"
  );
};

const getNewsArray = () => {
  return api.get(config.wppath+"wp-json/wp/v2/news?_embed");
};

const getSpecialsArray = () => {
  return api.get(config.wppath+"wp-json/wp/v2/specials?_embed");
};

const getMinimalData = () => {
  return api.get(config.apipath+"?action=get_minimal");
};

const getBookmarks = (pid, token) => {
  return api.get(
    config.apipath+"?action=get_bookmarks&pid=" +
      pid +
      "&token=" +
      token
  );
};

const setBookmarks = (pid) => {
  //return api.get("https://bordatlas.marketersandnerds.dev/api/?action=get_bookmarks&pid="+pid);
};

const getUsedVouchers = (pid, token) => {
  return api.get(
    config.apipath+"?action=get_used_vouchers&pid=" +
      pid +
      "&token=" +
      token
  );
};

const saveUsedVouchers = (data, pid, token) => {
  var savedataParm = JSON.stringify(data);
  return axios.post(
    config.apipath+"?action=update_used_vouchers&savedataParm=" +
      savedataParm +
      "&pid=" +
      pid +
      "&token=" +
      token,
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    }
  );
};

const saveUsedVoucher = (data, pid, token) => {
  return axios.get(
    config.apipath+"?action=update_used_voucher&vid=" +
      data +
      "&pid=" +
      pid +
      "&token=" +
      token
  );
};

const saveBookmarksURL =
  config.apipath+"?action=update_bookmarks";

const getRouteContent = (list, pid, token) => {
  return api.get(
    config.apipath+"?action=getRouteContent&list=" +
      list +
      "&pid=" +
      pid +
      "&token=" +
      token
  );
};

const getCustomRouteContent = (from, to, token) => {
  return api.get(
    config.apipath+"?action=getCustomRouteContent&from=" +
      from +
      "&to=" +
      to +
      "&token=" +
      token
  );
};

const getLastRoute = (pid, token) => {
  return api.get(
      config.apipath+"?action=get_userroutes" +
      "&pid=" +
      pid +
      "&token=" +
      token
  );
};

const setLastRoute = (pid, token, savedata) => {

  var savedataParm =JSON.stringify(savedata) + "&pid=" + pid + "&token=" + token;

  return api.get(
      config.apipath+"?action=set_userroute&savedataParm=" + savedataParm +
      "&pid=" +
      pid +
      "&token=" +
      token
  );

};



const getPelnigoAccessItemsFromAPI = (pid, token) => {
  return api.get(
    config.apipath+"?action=get_access_rights&pid=" +
      pid +
      "&token=" +
      token
  );
};


const getIDsContent = (ids) => {
  return api.get(
      config.apipath+"?action=search&hasfilter=1&ids="+ids
  );
};


const checkPlenigoAccessItem = (accessIds) => {
  var rt = false;
  if(window.accessRights === null) {
    return false;
  }
  window.accessRights.forEach((element) => {
    accessIds.forEach((accessId) => {
      if (
        accessId == element.accessRightUniqueId ||
        element.accessRightUniqueId == "aktivesabo"
      ) {
        rt = true;
      }
    });
  });

  return rt;
};

const saveBookmarks = (data, pid, token) => {
  var savedataParm = JSON.stringify(data);
  return axios.post(
    saveBookmarksURL +
      "&savedataParm=" +
      savedataParm +
      "&pid=" +
      pid +
      "&token=" +
      token,
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    }
  );
};

const favUpdate = (pid, type) => {

};

const getUserData = () => {
  try {
    if (typeof window.parent.getToken !== "undefined") {
      var rtData = window.parent.getToken();

      if (rtData.cookie != "") {
        rtData.tokenData = parseJwt(rtData.cookie);
      } else {
        rtData.tokenData = [];
      }
    } else {
      rtData = fallbackLogin();
    }
  } catch (error) {
    console.error(error);

    var rtData = fallbackLogin();
  }

  return rtData;
};

function fallbackLogin() {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());

  if (
    typeof params.sso_session !== "undefined" &&
    params.sso_session !== null &&
    params.sso_session !== ""
  ) {
    var tokenData = parseJwt(params.sso_session);
    var login = 1;
  } else {
    var tokenData = "";
    var login = 0;
  }

  var rtData = {
    tokenData: tokenData,
    login: "1",
    pro: "0",
    cookie: params.sso_session,
  };


  if (window.location.hostname === "localhost" ) {
    rtData.pro = 1;
  }


  return rtData;
}

function parseJwt(token) {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
}

/* const getDestinationArray = () => {
  return api.get("https://ba.marketersandnerds.dev/wp-json/wp/v2/reiseziele?_embed");
};

const getTourenStopArray = () => {
  return api.get("https://ba.marketersandnerds.dev/wp-json/wp/v2/posts?_embed");
}; */

/* ÄNDERN IN DATEN DIE GESCHICKT WERDEN */
const getPreviousSearchs = (pid, token) => {
  return api.get(
    config.apipath+"?action=get_lastsearch&pid=" +
      pid +
      "&token=" +
      token
  );
};

const goToURL = (url) => {
  if (typeof window.parent.goToURL !== "undefined") {
    window.parent.goToURL(url);
  } else {
    window.location.href = url;
  }
};

/*
const getModeratorBoard = () => {
  return api.get("/test/mod");
};
const getAdminBoard = () => {
  return api.get("/test/admin");
}; */
const UserService = {
  getPublicContent,
  getProfileFields,
  getDetailFields,
  getPreviousSearchs,
  getBookmarks,
  getTourenArray,
  getNewsArray,
  getSpecialsArray,
  favUpdate,
  setBookmarks,
  getMinimalData,
  getUserData,
  saveBookmarksURL,
  saveBookmarks,
  getUsedVouchers,
  saveUsedVouchers,
  saveUsedVoucher,
  getRouteContent,
  getCustomRouteContent,
  getPelnigoAccessItemsFromAPI,
  checkPlenigoAccessItem,
  getLastRoute,
  setLastRoute,
  goToURL,
  getIDsContent,
  /* getDestinationArray,
  getTourenStopArray, */
};
export default UserService;
